var map = {
	"./chemicals.js": "f212",
	"./goods.js": "9442",
	"./help.js": "bf39",
	"./home.js": "9f25",
	"./magazine.js": "c961",
	"./my.js": "33ad",
	"./user.js": "2963"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d56b";